import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
const Container = styled.div `
  display: flex;
  margin-bottom: 6px;
  color: #3b3b3b;
  margin-left: 4px;
  font-size: 14px;
`;
const CompanyName = ({ name, className }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, { className: className },
        t('by'),
        " ",
        name));
};
export default CompanyName;
